import { lazy } from "react";
import LazyRoute from "../components/Common/LazyRoute";
import ROUTES from "./ROUTES";

const ParentDashboardView = lazy(() => import("@/components/Dashboard/ParentDashboardView"));
const Charts = lazy(() => import("../components/Dashboard/Charts/Charts.jsx"));

export default [
  {
    path: ROUTES.ROOT,
    // element: <ProtectedRoute element={<LazyRoute><App /></LazyRoute>} />,
    children: [
      { path: ROUTES.DASHBOARD, element: <LazyRoute><ParentDashboardView /></LazyRoute> },
      { path: ROUTES.CHARTS, element: <LazyRoute><Charts /></LazyRoute> },
    ],
  },
];
